// extracted by mini-css-extract-plugin
export var container = "subscribe-all-module--container--83396";
export var container__leftArrow = "subscribe-all-module--container__leftArrow--8f9bd";
export var container__rightArrow = "subscribe-all-module--container__rightArrow--7316d";
export var grid = "subscribe-all-module--grid--f6922";
export var heading = "subscribe-all-module--heading--b3f3e";
export var phone = "subscribe-all-module--phone--2b783";
export var spacer = "subscribe-all-module--spacer--20e74";
export var spin = "subscribe-all-module--spin--fbb5d";
export var subscribe = "subscribe-all-module--subscribe--08ebd";
export var vertical = "subscribe-all-module--vertical--d7549";
export var wiggleLeft = "subscribe-all-module--wiggleLeft--04dfd";
export var wiggleRight = "subscribe-all-module--wiggleRight--bf244";